import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { IGetBook } from '../../../core/modules/book/book.model';
import { getDate } from './getDate';
import { getExportHeaders } from './getExportHeaders';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const getResult = (tags1, tags2) => {
  if (tags1 === '') {
    if (tags2 === '') {
      return '';
    } else {
      return tags2;
    }
  } else if (tags2 === '') {
    if (tags1 === '') {
      return '';
    } else {
      return tags1;
    }
  } else {
    return `${tags1},\n${tags2}`;
  }
};

const generatePDF = (
  data: IGetBook[],
  id: string,
  chekedColumns: CheckboxValueType[],
  type: string,
  orderedColumns?: string[]
  // eslint-disable-next-line max-params
) => {
  // Mirrors the user's "Arrange columns" layout when one is applied.
  const headers = getExportHeaders(id, chekedColumns, orderedColumns).map(name => ({
    text: name,
    style: 'tableHeader',
    alignment: 'center'
  }));

  const date = getDate();
  const date_regex = /^\d{4}-\d{2}-\d{2}$/;

  if (window.location.pathname.includes('daily-rank')) {
    headers.unshift({ text: 'Title', style: 'tableHeader', alignment: 'center' });
    const date_head = data.length > 0 ? Object.keys(data[0])
      .filter(d => date_regex.exec(d))
      .reverse()
      .slice(0, 16) : [];

    for (const name of date_head) {
      headers.push({
        text: name,
        style: 'tableHeader',
        alignment: 'center'
      });
    }
  }

  const columns = data.map(book =>
    headers.map(({ text }) => {
      switch (text) {
      case 'Tags' : {
        const tags1 = book['Primary Tags']?.split(',').join(',\n') ?? '';
        const tags2 = book['Secondary Tags']?.split(',').join(',\n') ?? '';
        const result = getResult(tags1, tags2);

        return {
          text: result,
          fontSize: 7
        };
      }
      case 'First 12 months sales (units)' : {
        const splitData = book['First Year Audiobooks Sold']?.split(',') ?? '';
        const value = splitData ? splitData[splitData?.length - 1] : '-';

        return {
          text: value,
          fontSize: 7
        };
      }
      case 'Trailing 12 months sales (units)' : {
        const splitData = book['Trailing Year Audiobooks Sold']?.split(',');
        const value = splitData ? splitData[splitData?.length - 1] : '-';

        return {
          text: value,
          fontSize: 7
        };
      }
      case 'Lifetime sales (units)': {
        const splitData = book['Lifetime Audiobooks Sold']?.split(',');
        const value = splitData ? splitData[splitData?.length - 1] : '-';

        return {
          text: value,
          fontSize: 7
        };
      }
      case 'Lifetime sales (dollars)' : {
        const splitData = book['Lifetime Sales']?.split(',');
        const value = splitData ? splitData[splitData?.length - 1] : '-';

        return {
          text: value,
          fontSize: 7
        };
      }
      case 'Kindle Unlimited' : {
        return { text: book[text] ? 'Yes' : 'No', fontSize: 7 };
      }
      case 'Audible Product ID': {
        return { text: book['Podium Id'], fontSize: 7 };
      }
      case 'Series': {
        return { text: book['Series'] ?? '', fontSize: 7 };
      }
      default : {
        if (text.match(date_regex)) {
          return { text: book[text] ?? '-', fontSize: 7 };
        }

        return { text: book[text] ?? 0, fontSize: 7 };
      }
      }
    })
  );

  // Equal share per column, so the table always spans exactly the page width.
  const widths: Array<string | number> = headers.map(() => `${100 / headers.length}%`);

  const docInfo = {
    info: {
      title: `report_${date}`,
      author: 'Brenda',
      subject: 'Titles'
    },
    pageSize: 'A4',
    pageOrientation: 'landscape',
    pageMargins: [10, 10, 10, 10],

    header(currentPage, pageCount) {
      return {
        text: `${currentPage.toString()}/${pageCount}`,
        alignment: 'right',
        margin: [0, 0, 0, 0]
      };
    },
    content: [
      {
        margin: [0, 0, 0, 0],
        table: {
          widths,
          body: [headers, ...columns]
        }
      }
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 7,
        color: 'black'
      }
    }
  };

  pdfMake.createPdf(docInfo).download(`report_${date}.${type}`);
};

export default generatePDF;